import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Header from "components/ui/Header";
import NavigationStateManager from "components/ui/NavigationStateManager";
import StoreSelectionLandingPage from "pages/HomePage";
import ProductListingPage from "pages/product-listing-page";
import ProductDetailPage from "pages/product-detail-page";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <NavigationStateManager>
          <ScrollToTop />
          <Header />
          <div className="pt-16">
            <RouterRoutes>
              <Route path="/" element={<StoreSelectionLandingPage />} />
              <Route path="/HomePage" element={<StoreSelectionLandingPage />} />
              <Route
                path="/product-listing-page"
                element={<ProductListingPage />}
              />
              <Route
                path="/product-detail-page"
                element={<ProductDetailPage />}
              />
            </RouterRoutes>
          </div>
        </NavigationStateManager>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
